export default __webpack_public_path__ + "static/media/Resume.0bf404e4.pdf";